<template>
  <div>
    <div class="row">
      <b-form-group
          :label="`${lodash.upperFirst($t('purchase_orders.ticket_id'))}*`"
          class="col-md-6 mb-3"
          label-cols-md="12"
      >
        <input :value="ticketValueFormatter((model || {}).ticket)" class="form form-control" disabled>
      </b-form-group>
      <validation-provider
          v-if="!useDownPaymentProduct"
          v-slot="{ validated, errors }"
          :name="$t('purchase_orders.send_to_rfq')"
          class="col-md-6"
          vid="send_to_rfq"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="$t('purchase_orders.forms.send_to_rfq_question')"
            :state="errors[0] ? false : validated ? true : null"
            class="row mb-3"
            label-cols-md="12"
        >
          <b-form-checkbox
              v-model="model.send_to_rfq"
              :unchecked-value="false"
              :value="true"
              name="send_to_rfq"
              stacked
          />
        </b-form-group>
      </validation-provider>
      <b-form-group
          v-if="model.initial_type !== 'down_payment'"
          :label="`${lodash.upperFirst($t('products.singular'))}*`"
          class="mb-3 col-md-6"
          label-cols-md="12"
      >
        <input :value="productLabel(model)" class="form form-control" disabled>
      </b-form-group>
      <validation-provider
          v-else
          v-slot="{ validated, errors }"
          :name="lodash.upperFirst($t('products.singular'))"
          class="col-md-6" rules="required"
          vid="shrimp_id"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="`${lodash.upperFirst($t('products.singular'))}`"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-cols-md="12"
        >
          <product-select-ajax
              :key="`shrimps-${model.ticketable.ticket_id}`"
              v-model.number="model.product_id"
              :disabled="productDisabledRules"
              :modify-response="productModifyResponse"
              :params="productFetchParameter"
              :placeholder="`${$t('Choose {something}', {
                something: $t('products.singular')
              })}`"
              name="shrimp_id"
              @update:selected="productSelected"
          ></product-select-ajax>
        </b-form-group>
      </validation-provider>
      <validation-provider
          v-if="model.type!=='down_payment'"
          v-slot="{ validated, errors }"
          :name="lodash.upperFirst($t('purchase_orders.service_fee'))"
          class="col-md-6"
          rules="required|min_value:0"
          vid="service_fee"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="`${lodash.upperFirst($t('margin_per_kg'))}*`"
            :state="errors[0] ? false : validated ? true : null"
            class="row mb-3"
            label-cols-md="12"
        >
          <b-input-group prepend="Rp">
            <numeral-input
                id="service_fee"
                v-model="model.service_fee"
                :disabled="model.type === 'harvest'"
                :placeholder="lodash.upperFirst($t('margin_per_kg'))"
                :state="errors[0] ? false : validated ? true : null"
                format="0,0.[00]"
                lazy-formatter
                name="service_fee"
                style="text-align: right"
            />
          </b-input-group>
        </b-form-group>
      </validation-provider>
    </div>
    <div class="row">
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.startCase($t('purchase_orders.partner'))"
          class="col-md-4"
          rules="required"
          vid="customer_id"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase($t('purchase_orders.partner')) + '*'"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-cols-md="12"
        >
          <multiselect-ajax
              :key="`${_uid}-customers-${model.ticketable.ticket_id}`"
              v-model.number="model.customer_id"
              :custom-label="(m) => m.code ? `${m.name} (${m.code})` : m.name"
              :disabled="!model.ticketable.ticket_id"
              :params="{ active: 1, type__like_in: `lcs,brs` }"
              :url="`/customers`"
              name="customer_id"
              @input="emitModel"
              @update:selected="onCustomerSelected"
          >
            <template v-slot:beforeList>
              <b-button v-b-modal.customer-create-modal variant="link">+
                {{ $t('Add new {something}', {something: $t('receipt_orders.customer')}) }}
              </b-button>
              <customer-create-modal
                  id="customer-create-modal"
                  :key="`customer-create-modal-${model.ticket.customer_type}-${model.customer_id}`"
                  :deny-customer-select="true"
                  :initial-value="{ type: model.ticket.customer_type }"
                  :modal-title="`BUAT PELANGGAN BARU`"
                  @created="$set(model, 'customer_id', $event.id)"
              ></customer-create-modal>
            </template>
          </multiselect-ajax>
        </b-form-group>
      </validation-provider>
      <validation-provider v-slot="{ validated, errors }" :name="$t('purchase_orders.farmer_id')" class="col-md-4"
                           vid="farmer_id">
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase($t('purchase_orders.from_farmer'))"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-cols-md="12"
        >
          <multiselect-ajax
              :key="`${_uid}-farmers`"
              v-model.number="model.farmer_id"
              :custom-label="farmerLabel"
              :params="{ type: 'farmer', active: 1 }"
              :url="`/customers`"
              name="farmer_id"
              @input="emitModel"
              @update:selected="onFarmerSelected($event);"
          >
            <template v-slot:beforeList>
              <b-button v-b-modal.customer-farmer-create-modal variant="link">
                + {{ $t('Add new {something}', {something: $t('purchase_orders.from_farmer')}) }}
              </b-button>
              <customer-create-modal
                  id="customer-farmer-create-modal"
                  :key="`customer-create-modal-${model.farmer_id}`"
                  :initial-value="{ type: ['farmer'] }"
                  :modal-title="`BUAT TAMBAK BARU`"
                  @created="(event) => {
                      $set(model, 'farmer_id', event.id);
                      $nextTick(() => {
                        $refs.farm_multiselect.fetchOptions()
                      })
                    }"
              ></customer-create-modal>
            </template>
          </multiselect-ajax>
        </b-form-group>
      </validation-provider>
      <validation-provider
          v-if="!useDownPaymentProduct"
          v-slot="{ validated, errors }"
          :name="$t('purchase_orders.vendor_selection')"
          class="col-md-4"
          vid="farmer_id">
        <b-form-group
            :invalid-feedback="errors[0]"
            :state="errors[0] ? false : validated ? true : null"
            class="row mb-3"
            label="Petambak sebagai Vendor di RFQ?"
            label-cols-md="12"
        >
          <b-form-radio-group
              v-model="model.vendor_selection"
              :disabled="!model.farmer_id"
              :options="vendor_selection_options"
              name="vendor_selection"
              stacked
          />
        </b-form-group>
      </validation-provider>
      <validation-provider v-slot="{ validated, errors }" :name="$t('purchase_orders.farm_id')" class="col-md-4"
                           vid="farm_id">
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="'Nama Tambak'"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-cols-md="12"
        >
          <multiselect-ajax
              :key="`${_uid}-farms`"
              ref="farm_multiselect"
              v-model.number="model.farm_id"
              :custom-label="(m) => [m.name, m.region_full_name].join(' - ')"
              :params="{ customer_id: model.farmer_id }"
              :url="`/farms`"
              name="farm_id"
              @update:selected="farm => $set(model, 'farm', farm)"
              @input="emitModel"
          >
            <!-- <template v-slot:beforeList>
              <b-button variant="link" v-b-modal.customer-farmer-create-modal>
                + {{ $t('Add new {something}',  { something: $t('purchase_orders.from_farmer') }) }}
              </b-button>
              <customer-create-modal
                  :key="`customer-create-modal-${selectedCustomerType}-${model.farmer_id}`"
                  id="customer-farmer-create-modal"
                  :initial-value="{ type: ['farmer'] }"
              ></customer-create-modal>
            </template> -->
          </multiselect-ajax>
        </b-form-group>
      </validation-provider>
    </div>
    <div class="row">
      <validation-provider
          v-if="!isDownPaymentService"
          v-slot="{ validated, errors }"
          :name="lodash.upperFirst($t('purchase_orders.hatchery_id'))"
          class="col-md-6"
          vid="hatchery_id">
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="`${lodash.upperFirst($t('purchase_orders.hatchery'))}`"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-cols-md="12"
        >
          <manufacture-select-ajax
              :key="`${_uid}-hatchery`"
              ref="hatchery_multiselect"
              v-model.number="model.hatchery_id"
              :params="{ type: 'seed', is_active: 1, or_where_id__in: model.hatchery_id }"
              name="hatchery_id"
          >
          </manufacture-select-ajax>
        </b-form-group>
      </validation-provider>
      <validation-provider v-if="!isDownPaymentService" v-slot="{ validated, errors }"
                           :name="lodash.upperFirst($t('purchase_orders.feed_product_id'))"
                           class="col-md-6" rules="max:255"
                           vid="feed_product_id">
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="`${lodash.upperFirst($t('feeds.plural'))}`"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-cols-md="12"
        >
          <multiselect-ajax
              :key="`${_uid}-feed-products`"
              ref="feed_product_multiselect"
              v-model="model.feed_product_ids"
              :custom-label="({name}) => name"
              :params="feedProductParams"
              :url="`/v1/feed_products`"
              name="feed_product_ids"
              :multiple="true"
          >
          </multiselect-ajax>
        </b-form-group>
      </validation-provider>
    </div>

    <div class="row">
      <validation-provider v-if="isDownPaymentService" v-slot="{ validated, errors }
          " :name="lodash.upperFirst($t('purchase_orders.estimated_ordered_at'))"
                           :rules="estimatedHarvestRules"
                           class="col-md-6"
                           vid="estimated_harvest_date">
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.upperFirst($t('purchase_orders.estimated_ordered_at')) + '*'"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-cols-md="12"
        >
          <date-picker
              v-model="model.estimated_harvest_date"
              :state="errors[0] ? false : (validated ? true : null)"
              format="DD MMMM YYYY"
              name="estimated_harvest_date"
              required
              type="date"
              @input="emitModel"
          >
          </date-picker>
        </b-form-group>
      </validation-provider>
      <validation-provider
          v-else
          v-slot="{ validated, errors }"
          :name="lodash.upperFirst($t('purchase_orders.ordered_at'))"
          :rules="`required|before_or_equal:${this.$moment().format('YYYY-MM-DD')}`"
          class="col-md-4"
          vid="ordered_at">
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.upperFirst($t('purchase_orders.ordered_at')) + '*'"
            :state="errors[0] ? false : (validated ? true : null)"
            class="row mb-3"
            label-cols-md="12"
        >
          <date-picker
              v-model="model.ordered_at"
              :state="errors[0] ? false : (validated ? true : null)"
              format="DD MMMM YYYY"
              name="ordered_at"
              required
              type="date"
              @input="emitModel"
          >
          </date-picker>
        </b-form-group>
      </validation-provider>
      <template v-if="model.type === 'hybrid'">
        <validation-provider v-slot="{ validated, errors }"
                             :name="lodash.upperFirst($t('purchase_orders.top'))"
                             class="col-md-4" rules="required|min_value:0"
                             vid="top">
          <b-form-group
              :invalid-feedback="errors[0]"
              :label="`${lodash.upperFirst($t('purchase_orders.top'))}*`"
              :state="errors[0] ? false : (validated ? true : null)"
              class="row mb-3"
              label-cols-md="12"
          >
            <b-input-group :append="$t('units.days')">
              <b-form-input
                  id="top"
                  v-model.number="model.duration"
                  :placeholder="lodash.upperFirst($t('purchase_orders.top'))"
                  :state="errors[0] ? false : (validated ? true : null)"
                  name="top"
                  style="text-align: right"
                  type="number"
              />
            </b-input-group>
          </b-form-group>
        </validation-provider>
        <div class="col-md-4">

          <b-form-group
              :label="`${lodash.upperFirst($t('due_date'))}*`"
              class="row mb-3"
              label-cols-md="12"
          >
            <b-form-input
                :value="dueDate"
                readonly
            />
          </b-form-group>
        </div>
      </template>
    </div>
    <b-form-group
        v-if="model.initial_type !== 'down_payment' || !isDownPaymentService"
        :label="'Attachment (PNG, JPG, PDF)'"
        class="row mb-3"
        label-cols-md="12"
    >
      <div key="invoice_document" class="row g-2 mt-2">
        <validation-provider
            :key="model.invoice_document.preview"
            v-slot="{ validated, errors }"
            :name="lodash.upperFirst($t('purchase_payments.invoice_document'))"
            vid="invoice_document"
            rules="files_mimes:image/jpeg,image/png,application/pdf"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :state="errors[0] ? false : (validated ? true : null)"
          >
            <div class="row">
              <div class="col-md-6">
                <file-drag-and-drop
                    v-model="model.invoice_documents"
                    :drop-placeholder="lodash.upperFirst($t('drop file here'))"
                    :placeholder="lodash.upperFirst($t('choose a file or drop it here'))"
                    :state="errors[0] ? false : (validated ? true : null)"
                    accept="image/jpeg,image/png,application/pdf"
                    name="invoice_document"
                ></file-drag-and-drop>
              </div>
            </div>
          </b-form-group>
          <div class="col-md-12">
            <div class="d-flex flex-wrap gap-2">
              <template v-for="(file, index) in model.invoice_documents">
                <file-item
                    v-if="file._action !== 'delete'"
                    :key="index"
                    :deletable="true"
                    :file="file"
                    @delete="removeInvoiceDocument(index)"
                ></file-item>
              </template>
            </div>
          </div>
        </validation-provider>
      </div>
    </b-form-group>
    <b-form-group
        v-if="model.type === 'down_payment' || model.down_payment"
        :label="'Dokumen Down Payment (PNG, JPG, PDF)'"
        class="row mb-3"
        label-cols-md="12"
    >
      <div key="down_payment_document" class="row g-2 mt-2">
        <validation-provider
            :key="model.down_payment_document.preview"
            v-slot="{ validated, errors }"
            :name="lodash.upperFirst($t('purchase_payments.down_payment_document'))"
            vid="down_payment_document"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :state="errors[0] ? false : (validated ? true : null)"
          >
            <div class="row">
              <div v-if="isDownPaymentService" class="col-md-6">
                <file-drag-and-drop
                    :drop-placeholder="lodash.upperFirst($t('drop file here'))"
                    :placeholder="lodash.upperFirst($t('choose a file or drop it here'))"
                    :state="errors[0] ? false : (validated ? true : null)"
                    accept="image/jpeg, application/pdf"
                    name="`down_payment_document`"
                    @change="addFile('down_payment_documents', $event)"
                ></file-drag-and-drop>
              </div>
              <template
                  v-for="(file, index) in model.down_payment_documents"
              >
                <preview-image-pdf
                    v-if="file._action !== 'delete'"
                    :key="index"
                    :deletable="isDownPaymentService"
                    :file="file"
                    :format="file.extension"
                    :preview="file.preview"
                    :preview-image="false"
                    :preview-pdf="false"
                    class="col-md-3 mb-2"
                    image-style="height: 200px; width: 100%; object-fit: contain;"
                    @delete="removeFile(file)"
                />
              </template>
            </div>
          </b-form-group>
        </validation-provider>
      </div>
    </b-form-group>
    <validation-provider v-if="isDownPaymentService" v-slot="{ validated, errors }"
                         :name="lodash.startCase($t('purchase_orders.down_payment'))" rules="required|gt:0"
                         vid="down_payment">
      <b-form-group
          :invalid-feedback="errors[0]"
          :label="`${lodash.startCase($t('purchase_orders.down_payment'))}*`"
          :state="errors[0] ? false : (validated ? true : null)"
          class="row mb-3"
          label-cols-md="12"
          style="font-style: italic;"
      >
        <numeral-input
            id="down_payment"
            v-model.number="model.down_payment"
            :disabled="downPaymentDisabledRules"
            :placeholder="'Rp'"
            :state="errors[0] ? false : (validated ? true : null)"
            format="$ 0,0.[00]"
            lazy-formatter
            name="down_payment"
            @blur="updateLocalStorage"
            @change="$emit('input', model)"
        />
      </b-form-group>
    </validation-provider>
    <hr v-if="model.ticket.customer_type === 'lcs'">
    <div v-if="!isDownPaymentService">
      <b-form-group
          :label="lodash.startCase($t('purchase_orders.purchase_item'))"
          class="mb-3"
          label-class="custom-label-form-group"
          label-cols-sm="12"
      >
        <template #label>
          <div class="d-flex justify-content-between section-label">
            <div class="text-primary align-items-center">{{
                lodash.upperCase($t('purchase_orders.purchase_item'))
              }}
            </div>
            <b-button
                v-if="undeletedItems('purchase_items').length === 0"
                variant="link-success"
                @click="addItem('purchase_items')"
            ><u class="text-success">Tambah item nota panen</u></b-button>
          </div>
        </template>
        <template v-if="undeletedItems('purchase_items').length">
          <template v-for="(purchase_item, key) in model.purchase_items">
            <template v-if="purchase_item._action !== 'delete'">
              <b-form-group
                  v-bind:key="key"
                  class="row mb-3"
              >
                <div class="row">
                  <validation-provider v-slot="{ validated, errors }"
                                       :name="lodash.upperFirst($t('purchase_orders.quality'))"
                                       :vid="`purchase_items.${key}.quality`"
                                       class="col-sm-6 col-md-3 col-lg-3 col-xl-2 mt-2" rules="required">
                    <b-form-group
                        :invalid-feedback="errors[0]"
                        :label="`${lodash.startCase($t('purchase_orders.quality'))}*`"
                        :state="errors[0] ? false : (validated ? true : null)"
                    >
                      <b-form-select
                          id="quality"
                          v-model="purchase_item['quality']"
                          :name="`purchase_items[${key}][quality]`"
                          :options="quality_options"
                          :placeholder="lodash.upperFirst($t('purchase_orders.quality'))"
                          :state="errors[0] ? false : (validated ? true : null)"
                          @blur="updateLocalStorage"
                      />
                    </b-form-group>
                  </validation-provider>
                  <validation-provider
                      v-slot="{ validated, errors }"
                      :name="lodash.upperFirst($t('purchase_orders.doc'))"
                      :vid="`purchase_items.${key}.doc`"
                      class="col-sm-6 col-md-3 col-lg-3 col-xl-2 mt-2"
                      rules="gt:0|integer"
                  >
                    <b-form-group
                        :invalid-feedback="errors[0]"
                        :label="`${lodash.upperFirst($t('purchase_orders.doc'))} (${$t('Days')})`"
                        :state="errors[0] ? false : (validated ? true : null)"
                    >
                      <b-input-group>
                        <numeral-input
                            id="doc"
                            v-model="purchase_item['doc']"
                            :name="`purchase_items[${key}][doc]`"
                            :placeholder="`${lodash.upperFirst($t('purchase_orders.doc'))} (${$t('Days')})`"
                            :state="errors[0] ? false : (validated ? true : null)"
                            style="text-align: right"
                            @blur="updateLocalStorage"
                        />
                      </b-input-group>
                    </b-form-group>
                  </validation-provider>
                  <validation-provider
                      v-slot="{ validated, errors }"
                      :name="lodash.upperFirst($t('purchase_orders.biomassa'))"
                      :vid="`purchase_items.${key}.quantity`"
                      class="col-sm-6 col-md-3 col-lg-3 col-xl-2 mt-2"
                      rules="required|gt:0"
                  >
                    <b-form-group
                        :invalid-feedback="errors[0]"
                        :label="`${lodash.upperFirst($t('purchase_orders.biomassa'))} (${lodash.upperFirst($t('units.kg'))})*`"
                        :state="errors[0] ? false : (validated ? true : null)"
                    >
                      <b-input-group>
                        <numeral-input
                            id="quantity"
                            v-model="purchase_item['quantity']"
                            :name="`purchase_items[${key}][quantity]`"
                            :placeholder="`${lodash.upperFirst($t('purchase_orders.biomassa'))} (${lodash.upperFirst($t('units.kg'))})`"
                            :state="errors[0] ? false : (validated ? true : null)"
                            style="text-align: right"
                            @input="onChangePurchaseItemQuantity(purchase_item)"
                        />
                      </b-input-group>
                    </b-form-group>
                  </validation-provider>
                  <validation-provider
                      v-slot="{ validated, errors }"
                      :name="lodash.upperFirst($t('purchase_orders.size'))"
                      :vid="`purchase_items.${key}.size`"
                      class="col-sm-6 col-md-3 col-lg-3 col-xl-2 mt-2"
                      rules="required|min_value:10"
                  >
                    <b-form-group
                        :invalid-feedback="errors[0]"
                        :label="`${lodash.upperFirst($t('purchase_orders.size'))}*`"
                        :state="errors[0] ? false : (validated ? true : null)"
                    >
                      <b-input-group>
                        <numeral-input
                            id="size"
                            v-model="purchase_item['size']"
                            :name="`purchase_items[${key}][size]`"
                            :placeholder="lodash.upperFirst($t('purchase_orders.size'))"
                            :state="errors[0] ? false : (validated ? true : null)"
                            style="text-align: right"
                            @blur="updateLocalStorage"
                        />
                      </b-input-group>
                    </b-form-group>
                  </validation-provider>
                  <validation-provider
                      v-slot="{ validated, errors }"
                      :name="lodash.upperFirst($t('purchase_orders.unit_price'))"
                      :rules="priceRules()"
                      :vid="`purchase_items.${key}.unit_price`"
                      class="col-sm-6 col-md-3 col-lg-4 col-xl-2 mt-2"
                  >
                    <b-form-group
                        :invalid-feedback="errors[0]"
                        :label="`${lodash.upperFirst($t('purchase_orders.unit_price'))}${isKmServiceSelected ? '' : '*'}`"
                        :state="errors[0] ? false : (validated ? true : null)"
                    >
                      <numeral-input
                          id="unit_price"
                          v-model="purchase_item['unit_price']"
                          :name="`purchase_items[${key}][unit_price]`"
                          :placeholder="lodash.upperFirst($t('purchase_orders.unit_price'))"
                          :state="errors[0] ? false : (validated ? true : null)"
                          format="$ 0,0.[00]"
                          lazy-formatter
                          required
                          style="text-align: right"
                          @input="onChangePurchaseItemUnitPrice(purchase_item)"
                      />
                    </b-form-group>
                  </validation-provider>
                  <b-form-group
                      :label="`${lodash.upperFirst($t('purchase_orders.total_price'))}${isKmServiceSelected ? '' : '*'}`"
                      class="col-sm-6 col-md-9 col-lg-8 col-xl-2 mt-2"
                  >
                    <numeral-input
                        id="total_unit_price"
                        :name="`purchase_items[${key}][total_price]`"
                        :placeholder="lodash.upperFirst($t('purchase_orders.total_price'))"
                        :value="purchase_item.quantity * purchase_item.unit_price"
                        disabled
                        format="$ 0,0.[00]"
                        lazy-formatter
                        style="text-align: right"
                        @blur="updateLocalStorage"
                    />
                  </b-form-group>
                </div>
              </b-form-group>
              <div :key="`purchase_items.key.${key}.delete`" class="row g-2">
                <div class="col-sm m-0 p-0">
                  <div class="float-start">
                    <b-button v-b-modal.shrimp-quality-modal variant="link-success"><u class="text-success">Pelajari
                      kualitas udang</u></b-button>
                  </div>
                  <div class="float-end">
                    <b-button v-if="undeletedItems('purchase_items').length > 0"
                              class="text-danger text-decoration-underline" style="margin-right: 10px;"
                              tag="span"
                              variant="link"
                              @click="removeItem('purchase_items', key)">{{ $t('Delete') }}
                    </b-button>
                    <b-button
                        v-if="key === latestIndexUndeletedItems('purchase_items') || undeletedItems('purchase_items').length === 0"
                        class="text-success text-decoration-underline" tag="span"
                        variant="link"
                        @click="addItem('purchase_items')">
                      Tambah item nota panen
                    </b-button>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </template>
        <template v-else>
          <div class="text-center empty-state">
            Belum ada item nota panen
          </div>
        </template>

      </b-form-group>
      <hr>
    </div>
    <span v-if="!isDownPaymentService">
            <b-form-group
                :label="lodash.startCase($t('purchase_orders.additional_fee'))"
                class="row mb-3"
                label-cols-md="12"
            >
              <template #label>
                <div class="d-flex justify-content-between section-label">
                  <div class="text-primary">{{ lodash.upperCase($t('purchase_orders.additional_fee')) }}</div>
                  <div><b-button v-b-modal.additional-fee-modal variant="link-success"><u class="text-success">Buat biaya tambahan</u></b-button></div>
                  <purchase-order-additional-item-modal
                      id="additional-fee-modal"
                      modal-title="Buat biaya tambahan"
                      nameLabel="Nama biaya"
                      totalLabel="Total biaya"
                      @ok="addItem('additional_fees', $event)"
                      @add-item="addItem('additional_fees')"
                      @remove-item="removeItem('additional_fees', $event)"
                  ></purchase-order-additional-item-modal>
                </div>
              </template>
              <div v-if="undeletedItems('additional_fees').length" class="row">
                <template v-for="(additional_item, key) in undeletedItems('additional_fees')">
                  <template v-if="additional_item._action !== 'delete'">
                    <div :key="`additional_fees.key.${key}`" :class="`row  col-md-4`">
                      <validation-provider v-slot="{ validated, errors }"
                                           :name="lodash.upperFirst($t('additional_fees.total'))"
                                           :vid="`additional_fees.${key}.total`"
                                           class="col-md-12" rules="required|gt:0"
                      >
                        <b-form-group
                            :invalid-feedback="errors[0]"
                            :label="`${lodash.upperFirst(additional_item['name'])}`"
                            :state="errors[0] ? false : (validated ? true : null)"
                        >
                          <numeral-input
                              :id="`${_uid}-value`"
                              v-model="additional_item['total']"
                              :name="`additional_fees[${key}][total]`"
                              :placeholder="lodash.upperFirst('Ex: 1000')"
                              :state="errors[0] ? false : (validated ? true : null)"
                              format="$ 0,0.[00]"
                              lazy-formatter
                              required
                              style="text-align: right"
                              @blur="onChangeAdditionalFeeTotal"
                          />
                        </b-form-group>
                        <div :key="`additional_fees.key.${key}.delete`" class="row">
                          <div class="col-sm delete-item">
                            <div class="float-end">
                              <b-button class="button-remove-item" size="sm" tag="span" variant="link"
                                        @click="removeItem('additional_fees', key)">{{ $t('Delete') }}</b-button>
                            </div>
                          </div>
                        </div>
                      </validation-provider>
                    </div>
                  </template>
                </template>
              </div>
              <div v-else class="text-center empty-state">
                Belum ada biaya tambahan
              </div>
            </b-form-group>
            <hr>
            <b-form-group
                :label="lodash.startCase($t('purchase_orders.discount'))"
                class="row mb-3"
                label-cols-md="12"
            >
              <template #label>
                    <div class="d-flex justify-content-between section-label">
                      <div class="text-primary">{{ lodash.upperCase($t('purchase_orders.discount')) }}</div>
                      <div><b-button v-b-modal.discounts variant="link-success"><u
                          class="text-success">Buat potongan biaya</u></b-button></div>
                      <purchase-order-additional-item-modal
                          id="discounts"
                          modal-title="Buat potongan biaya"
                          nameLabel="Nama biaya"
                          totalLabel="Total biaya"
                          @ok="addItem('discounts', $event)"
                          @add-item="addItem('discounts')"
                          @remove-item="removeItem('discounts', $event)"
                      ></purchase-order-additional-item-modal>
                    </div>
              </template>
              <div v-if="undeletedItems('discounts').length" class="row">
                <template v-for="(discount, key) in undeletedItems('discounts')">
                  <template v-if="discount._action !== 'delete'">
                    <div :key="`discounts.key.${key}`" :class="`row  col-md-4`">
                      <validation-provider v-slot="{ validated, errors }"
                                           :name="lodash.upperFirst($t('additional_fees.total'))"
                                           :vid="`discounts.${key}.total`"
                                           class="col-md-12" rules="required|gt:0"
                      >
                        <b-form-group
                            :invalid-feedback="errors[0]"
                            :label="`${lodash.upperFirst(discount['name'])}`"
                            :state="errors[0] ? false : (validated ? true : null)"
                        >
                          <numeral-input
                              :id="`${_uid}-value`"
                              v-model="discount['total']"
                              :name="`discounts[${key}][total]`"
                              :placeholder="lodash.upperFirst('Ex: 1000')"
                              :state="errors[0] ? false : (validated ? true : null)"
                              format="$ 0,0.[00]"
                              lazy-formatter
                              required
                              style="text-align: right"
                              @blur="onChangeDiscountTotal"
                          />
                        </b-form-group>
                        <div :key="`discounts.key.${key}.delete`" class="row">
                          <div class="col-sm delete-item">
                            <div class="float-end">
                              <b-button class="button-remove-item" size="sm" tag="span" variant="link"
                                        @click="removeItem('discounts', key)">{{ $t('Delete') }}</b-button>
                            </div>
                          </div>
                        </div>
                      </validation-provider>
                    </div>
                  </template>
                </template>
              </div>
              <div v-else class="text-center empty-state">
                Belum ada potongan biaya
              </div>
          </b-form-group>
          <hr>
          <b-form-group
              :label="lodash.startCase($t('purchase_orders.total_biomassa'))"
              class="row mb-3"
              label-cols-md="12"
          >
            <b-input-group :append="$t('units.kg')">
              <numeral-input
                  :disabled="true"
                  :value="purchaseOrderTotalTonase"
                  name="total"
                  style="text-align: right"
              />
            </b-input-group>
          </b-form-group>
          <validation-provider v-slot="{ validated, errors }" :name="lodash.upperFirst($t('purchase_orders.total'))"
                               :rules="totalPriceRules()"
                               vid="total">
            <b-form-group
                :invalid-feedback="errors[0]"
                :label="lodash.startCase($t('purchase_orders.total_price'))"
                :state="errors[0] ? false : (validated ? true : null)"
                class="row mb-3"
                label-cols-md="12"
            >
              <b-input-group>
                <numeral-input
                    id="total"
                    v-model.number="model.total"
                    :disabled="true"
                    :placeholder="lodash.upperFirst($t('purchase_orders.total'))"
                    :state="errors[0] ? false : (validated ? true : null)"
                    format="$ 0,0.[00]"
                    name="total"
                    style="text-align: right"
                />
              </b-input-group>
            </b-form-group>
          </validation-provider>
            <hr>
          </span>
    <template v-if="model.type === 'harvest'">
      <b-form-group
          :label="lodash.startCase($t('operational_costs.singular'))"
          class="row mb-3"
          label-cols-md="12"
      >
        <template #label>
          <div class="d-flex justify-content-between section-label">
            <div class="text-primary">
              {{ lodash.upperCase($t('operational_costs.singular')) }}
            </div>
          </div>
        </template>
        <div class="row px-2">
          <div class="col-md-4 row g-2 mb-2">
            <validation-provider
                v-slot="{ validated, errors }"
                :name="lodash.upperFirst($t('purchase_orders.mark_up'))"
                class="col-md-8"
                rules="min_value:0"
                vid="mark_up"
            >
              <b-form-group
                  :invalid-feedback="errors[0]"
                  :label="lodash.startCase($t('purchase_orders.mark_up'))"
                  :state="errors[0] ? false : validated ? true : null"
              >
                <b-input-group
                    append="/kg"
                >
                  <numeral-input
                      id="mark_up"
                      v-model.number="model.mark_up"
                      :disabled="markUpDisabledRules"
                      :placeholder="lodash.upperFirst($t('purchase_orders.mark_up'))"
                      :state="errors[0] ? false : validated ? true : null"
                      format="$ 0,0.[00]"
                      name="total"
                      style="text-align: right"
                  />
                </b-input-group>
              </b-form-group>
            </validation-provider>
          </div>
        </div>
        <div class="row px-2">
          <div class="col-md-6 row mt-3">
            <b-table-simple borderless class="w-100">
              <b-thead>
                <b-tr class="bg-slate-100 text-neutral-600">
                  <b-th>Glazing/Ice</b-th>
                  <b-th>Shipping</b-th>
                  <b-th>Labour</b-th>
                  <b-th>Total Biaya Operasional</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-td>{{ $numeral(costItem.ice).format('$ 0,0.[00]') }}</b-td>
                  <b-td>{{ $numeral(costItem.delivery).format('$ 0,0.[00]') }}</b-td>
                  <b-td>{{ $numeral(costItem.labour).format('$ 0,0.[00]') }}</b-td>
                  <b-td>{{ $numeral(model.total_operational_cost).format('$ 0,0.[00]') }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </div>
      </b-form-group>
    </template>
    <validation-provider v-slot="{ validated, errors }" :name="lodash.upperFirst($t('models.description'))"
                         rules="max:255"
                         vid="description">
      <b-form-group
          :invalid-feedback="errors[0]"
          :label="lodash.upperFirst($t('models.description'))"
          :state="errors[0] ? false : (validated ? true : null)"
          class="row mb-3"
      >
        <editor
            v-if="$parent.$parent.$options.name !== 'BModal'"
            ref="editor"
            v-model="model.description"
            :init="editorInit"
            class="form-control"
            inline
            plugins="lists link image paste help wordcount"
            toolbar="undo redo | styleselect | fontselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent"
            @input="emitModel"
        />
        <b-form-textarea v-else v-model="model.description"/>
      </b-form-group>
    </validation-provider>
  </div>
</template>

<script>
import CustomerCreateModal from '@/components/modals/customer-create'
import DatePicker from '@/components/inputs/datepicker'
import Editor from '@tinymce/tinymce-vue'
import MultiselectAjax from '@/components/inputs/vue-multiselect-ajax'
import NumeralInput from '@/components/inputs/numeral'
import FileDragAndDrop from "@/components/inputs/file-input";
import PurchaseOrderAdditionalItemModal from '../../../modals/purchase-order-additional-item'
import ProductSelectAjax from '@/components/inputs/product-select-ajax'
import ManufactureSelectAjax from "@/components/inputs/manufacture-select-ajax.vue";
import FileItem from "@/components/inputs/file-item.vue";

export default {
  name: 'before-payment',
  components: {
    FileItem,
    ManufactureSelectAjax,
    ProductSelectAjax,
    CustomerCreateModal,
    DatePicker,
    Editor,
    MultiselectAjax,
    NumeralInput,
    FileDragAndDrop,
    PurchaseOrderAdditionalItemModal,
  },
  props: ['value'],
  data() {
    return {
      vendor_selection_options: [
        {text: "Tidak", value: "supplier"},
        {text: "Ya", value: "farmer"},
      ],
      editorInit: {
        height: 512,
        image_title: true,
        automatic_uploads: true,
        file_picker_types: 'image',
        file_picker_callback: this.editorFilePickerCallback,
        mobile: {
          inline: true,
        },
      },
      file_accepts: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'],
      init: true,
      selectedCustomerType: null,
      quality_options: [
        {value: 'fresh', text: 'Fresh'},
        {value: 'km', text: 'Kulit Muda (KM)'},
        {value: 'bs', text: 'Below Standard (BS)'},
        {value: 'us', text: 'Under Size (US)'},
        {value: 'merah', text: 'Merah'},
      ],
      preview: '',
      firstFile: null,
      shrimp_selected: null,
      backupFile: {
        invoice_document: !this.lodash.isEmpty(this.value.invoice_document)
            ? this.value.invoice_document
            : {name: 'invoice_document'},
        down_payment_document: !this.lodash.isEmpty(this.value.down_payment_document)
            ? this.value.down_payment_document
            : {name: 'down payment document'},
      },
      model: {
        ...this.value,
        vendor_selection: this.value.odoo_purchase_order?.vendor_selection ?? 'supplier',
      },
    }
  },
  computed: {
    feedProductParams() {
      return {
        is_active: 1,
        sort: 'name,asc',
        or_where_id__in: this.model?.feed_products?.map(({id}) => id).join(',')
      }
    },
    dueDate() {
      let {ordered_at, duration, unit_duration} = this.model
      if (!ordered_at) {
        return '-'
      }
      return this.$moment(ordered_at, 'YYYY-MM-DD').add(duration ?? 0, unit_duration ?? 'days').format('D MMMM YYYY')
    },
    operationalDocumentState() {
      if (this.totalOperationalCost === 0) {
        return true
      }
      let filtered = [
        ...this.model.operational_cost_documents.filter(
            (value) => !this.lodash.isEmpty(value) && value._action !== 'delete')]
      return filtered.length > 0
    },
    totalOperationalCost() {
      let otherCost = this.model.other_operational_costs.reduce((carry, {total}) => carry + total, 0)
      return this.model.ice_cost + this.model.labour_cost + this.model.shipping_cost + otherCost
    },
    markUpDisabledRules() {
      const disabled = this.model.purchase_item_total_available_quantity < this.model.purchase_item_total_quantity
      return disabled
    },
    costItem() {
      return {
        ice: (this.model.total_operational_cost ?? 0) * 0.1508,
        labour: (this.model.total_operational_cost ?? 0) * 0.3823,
        delivery: (this.model.total_operational_cost ?? 0) * 0.4669,
      }
    },
    purchaseItemInitialValue() {
      return {
        quality: 'fresh',
        unit_price: this.isKmServiceSelected ? 0 : null,
      }
    },
    isDownPaymentService() {
      return this.model?.type === 'down_payment'
    },
    estimatedHarvestRules() {
      if (this.model.id) {
        const created_at = this.$moment(this.model.created_at).format('YYYY-MM-DD')
        return `required|after_or_equal:${created_at}`
      }
      return `required|after_or_equal:${this.$moment().format('YYYY-MM-DD')}`
    },
    downPaymentDisabledRules() {
      if (this.model.id) {
        if (this.model.paymentables.length > 0) {
          return true
        }
      }
      return false
    },
    productDisabledRules() {
      let hasPayment = this.model.paymentables.length > 0
      if (this.value.initial_type === 'down_payment' && !hasPayment) return true
      return this.value.initial_type !== 'down_payment';

    },
    orderedAtRules() {
      if (this.isDownPaymentService) {
        return `required|after_or_equal:${this.$moment().format('YYYY-MM-DD')}`
      }
      return `required|before_or_equal:${this.$moment().format('YYYY-MM-DD')}`
    },
    productFetchParameter() {
      let isPreviousSelectedDPProduct = this.value.product?.code === 'down_payment'
      let defaultParams = isPreviousSelectedDPProduct ? {} : {active: 1}

      if (this.value.ticket.customer_type === 'brs') {
        return {
          ...defaultParams,
          sort: 'name,asc',
          code__in: 'down_payment,hybrid',
        }
      }
      return {
        ...defaultParams,
        sort: 'name,asc',
        code__in: 'down_payment,cash,harvest,deposit_goods',
      }
    },
    purchaseAdditionalFeeTotal() {
      return this.model.additional_fees.filter(item => item._action !== 'delete').reduce((total, item) => total + (item.total || 0), 0)
    },
    purchaseDiscountTotal() {
      return -this.model.discounts.filter(item => item._action !== 'delete').reduce((total, item) => total + (item.total || 0), 0)
    },
    purchaseItemTotal() {
      return this.model.purchase_items.filter(item => item._action !== 'delete').reduce((total, item) => total + (item.total_price || 0), 0)
    },
    purchaseOrderSubTotal() {
      let iceCost = this.model.ice_cost || 0
      let shippingCost = this.model.shipping_cost || 0
      let labourCost = this.model.labour_cost || 0
      let operationalCostTotal = iceCost + shippingCost + labourCost +
          this.model.other_operational_costs?.reduce((carry, {total}) => carry + (total || 0), 0)

      return this.purchaseOrderTotalPrice + operationalCostTotal
    },
    purchaseOrderTotalPrice() {
      if (this.isDownPaymentService) {
        return this.model.down_payment
      }

      let purchaseItemTotal = this.model.purchase_items?.filter(purchaseItem => purchaseItem._action !== 'delete').reduce((total, v) => total + v.quantity * v.unit_price, 0)
      let additionalFeeTotal = this.model.additional_fees?.filter(additionalFee => additionalFee._action !== 'delete').reduce((total, v) => total + (v.total || 0), 0)
      let discounts = this.model.discounts?.filter(discount => discount._action !== 'delete').reduce((total, v) => total + (v.total || 0), 0)

      return purchaseItemTotal + additionalFeeTotal - discounts
    },
    purchaseOrderTotalTonase() {
      return (this.model.purchase_items.filter(purchaseItem => purchaseItem._action !== 'delete').reduce((total, v) => total + (v.quantity || 0), 0))
    },
    isKmServiceSelected() {
      return this.model.shrimp_selected?.code === 'deposit_goods'
    },
    ticketCustomerType() {
      return this.model?.ticket?.customer_type?.toLowerCase()
    },
    useDownPaymentProduct() {
      return this.model.shrimp_selected?.code === 'down_payment'
    },
  },
  watch: {
    'model.type': function (val, oldVal) {
      if (val !== oldVal) {
        if (val === 'deposit_goods') this.$set(this.model, 'purchase_items', this.model.purchase_items.map(item => ({
          ...item,
          unit_price: 0
        })))
      }
    },
    'model.farmer': function (val) {
      if (val && this.model.farm && this.model.farm.customer_id !== val.id) {
        this.model.farm_id = null
      }
    },
    model: function (val, oldVal) {
      if (!this.lodash.isEqual(val, oldVal)) {
        this.$emit('input', val)
      }
    },
    'model.purchase_items': {
      handler: function (newData) {
        let payload = {...this.model, purchase_items: newData}
        let isBrsTicket = this.model.ticket.customer_type === 'brs'
        let isCreatePage = !this.model.id

        if (isBrsTicket && isCreatePage) {
          localStorage.setItem('purchase_order', JSON.stringify(payload))
        }
        this.calculateOperationalCostTotal()
        this.$emit('input', this.model)
      },
      deep: true,
    },
    'model.additional_fees': function (newData) {
      let payload = {...this.model, additional_fees: newData}

      if (this.model.ticket.customer_type === 'brs') {
        localStorage.setItem('purchase_order', JSON.stringify(payload))
      } else {
        // localStorage.removeItem('purchase_order')
      }
      this.$emit('input', this.model)
    },
    'model.discounts': function (newData) {
      let payload = {...this.model, discounts: newData}
      if (!this.model.id && this.model.ticket.customer_type === 'brs') {
        localStorage.setItem('purchase_order',
            JSON.stringify(payload))
      }
      this.$emit('input', this.model)
    },
    'model.ticketable.ticket_id': function (newData, oldData) {
      const hasDraft = !!window.localStorage.getItem('purchase_order')
      if (hasDraft && !this.revert_ticket_id && oldData && oldData !== newData) {
        if (window.confirm('Data tidak tersimpan. Yakin mengganti ID Folder?')) {
          this.$set(this, 'model', {
            total: 0,
            service_fee: 0,
            customer_id: null,
            shrimp_id: null,
            farmer_id: null,
            ordered_at: null,
            hatchery_id: null,
            shrimp_selected: null,
            down_payment: null,
            feed: null,
            unit_duration: 'days',
            files: [{}],
            purchase_items: [
              {
                fund: 'fresh',
                quality: 'fresh',
                unit_price: this.value.type === 'deposit_goods' ? 0 : null,
              }],
            purchase_additional_items: [{}],
            additional_fees: [],
            discounts: [],
            ticketable: {ticket_id: this.model.ticketable.ticket_id},
            ticket: {...event},
            invoice_document: !this.lodash.isEmpty(this.value.invoice_document)
                ? this.value.invoice_document
                : {name: 'invoice_document'},
            down_payment_document: !this.lodash.isEmpty(this.value.down_payment_document)
                ? this.value.down_payment_document
                : {name: 'down payment document'},
            operational_cost_document: !this.lodash.isEmpty(this.value.operational_cost_document)
                ? this.value.operational_cost_document
                : {name: 'operational cost document'},
          })
          window.localStorage.removeItem('purchase_order')
        } else {
          this.revert_ticket_id = oldData
        }
      } else {
        this.revert_ticket_id = null
      }
    },
    'model.other_operational_costs': function () {
      this.$emit('input', this.model)
    },
    'model.mark_up': {
      immediate: true,
      handler: function () {
        this.calculateOperationalCostTotal()
        this.$emit('input', this.model)
      },
    },
  },
  methods: {
    productLabel(purchaseOrder) {
      if (this.lodash.isEmpty(purchaseOrder?.product)) return '-'
      return purchaseOrder.sub_product_name === '-' ? purchaseOrder.product.name : purchaseOrder.sub_product_name
    },
    productModifyResponse(value) {
      const {data: {data}} = value
      if (!data.length) return value
      value.data.data = [
        ...data.map(item => {
          return {
            ...item,
            $isDisabled: this.model.initial_type === 'down_payment' && item.code === 'deposit_goods',
          }
        }).sort((a) => !a.$isDisabled ? -1 : 1)
      ]
      return value
    },
    productSelected(payload) {
      if (!this.lodash.isEmpty(payload)) {
        this.model.type = payload.code
        this.$set(this.model, 'shrimp_id', payload && payload.id)
        this.$set(this, 'shrimp_selected', payload)
        if (this.model.id) {
          return null
        }
        if (this.model.ticket.customer_type === 'brs') {
          this.$set(this.model, 'duration', payload.duration || 0)
        }
        if (payload.code === 'deposit_goods') {
          this.$set(this.model, 'purchase_items', this.model.purchase_items.map(item => {
            return {
              ...item,
              unit_price: 0,
              total_price: 0,
            }
          }))
        }
        if (!this.model.id) {
          if (payload.code === 'down_payment') {
            this.$set(this.model, 'purchase_items', [{}])
            this.$set(this.model, 'additional_fees', [])
            this.$set(this.model, 'discounts', [])
          } else {
            this.$set(this.model, 'down_payment', null)
          }
        }
      } else {
        this.model.service_fee = 0
        this.model.duration = 0
      }
      this.setPurchaseOrderTotal()
    },
    calculateOperationalCostTotal() {
      if (this.model.type === 'harvest') {
        const totalQuantity = this.model.purchase_items.reduce((acc, curr) => ((curr.quantity || 0) + acc), 0)
        this.$set(this.model, 'total_operational_cost', this.model.mark_up * totalQuantity)
      }
    },
    addFile(key, file, index) {
      this.model[key].push({})
      if (!index) {
        index = this.model[key].length - 1
      }
      let vm = this
      let reader = new FileReader()
      let data = null
      // if file its a file object
      if (file instanceof File) {
        data = file
      } else {
        file.target.files[0]
      }
      if (!data) {
        setTimeout(function () {
          vm.model[key][index] = {...vm.backupFile[key]}
          return null
        }, 1000)
      }
      if (this.file_accepts.includes(data.type)) {
        reader.readAsDataURL(data)
        reader.onload = () => {
          this.$set(this.model[key][index], 'preview', reader.result)
          this.$set(this.model[key][index], 'extension', data.type)
          this.$set(this.model[key][index], 'file', data)
          this.$set(this.backupFile, key, {...this.model[key][index]})
        }
      }
    },
    removeFile(file) {
      this.$set(file, '_action', 'delete')
    },
    removeInvoiceDocument(fileIndex) {
      const filteredFile = this.model.invoice_documents
          .map((file, index) => {
            if (index == fileIndex && file.id) {
              file._action = "delete";
            }
            return file;
          })
          .filter((file, index) => {
            if (file._action === "delete") {
              return true;
            }
            return index !== fileIndex;
          });
      this.$set(this.model, 'invoice_documents', filteredFile);
    },
    onDeleteFile(file) {
      this.$set(this.model, file, {
        name: file,
        _action: 'delete',
      })
    },
    customerValueFormatter(customer) {
      if (this.lodash.isEmpty(customer)) {
        return '-'
      }
      return customer?.name
    },
    ticketValueFormatter(ticket) {
      if (this.lodash.isEmpty(ticket)) {
        return '-'
      }
      return `${ticket.id}: ${this.$t(`tickets.customer_types.${ticket.customer_type}`)}`
    },
    onFileChange(key, file) {
      let vm = this
      let reader = new FileReader()
      let data = null
      // if file its a file object
      if (file instanceof File) {
        data = file
      } else {
        file.target.files[0]
      }
      if (!data) {
        setTimeout(function () {
          vm.model[key] = {...vm.backupFile[key]}
          return null
        }, 1000)
      }
      if (this.file_accepts.includes(data.type)) {
        reader.readAsDataURL(data)
        reader.onload = () => {
          this.$set(this.model[key], 'preview', reader.result)
          this.$set(this.model[key], 'extension', data.type)
          this.$set(this.backupFile, key, {...this.model[key]})
        }
      }
    },
    setPurchaseOrderTotal() {
      this.$set(this.model, 'total',
          (this.purchaseItemTotal + this.purchaseAdditionalFeeTotal + this.purchaseDiscountTotal) || 0)
    },
    updateLocalStorage() {
      let payload = {...this.model}
      if (this.model.ticket.customer_type === 'lcs' && !this.model.id) {
        localStorage.setItem('purchase_order', JSON.stringify(payload))
      }
    },
    priceRules() {
      return {
        required: true,
        gt: 0,
      }
    },
    totalPriceRules() {
      return {
        required: true,
        gt: 0,
      }
    },
    checkLocalStorage() {
      let local = localStorage.getItem('purchase_order')
      if (local && !this.model.id) {
        let jsonData = JSON.parse(local)
        let vm = this
        this.$set(this, 'model', {
          total: 0,
          service_fee: 0,
          customer_id: null,
          shrimp_id: null,
          farmer_id: null,
          ordered_at: null,
          hatchery_id: null,
          shrimp_selected: null,
          down_payment: null,
          feed: null,
          ...jsonData,
          files: jsonData.files.map(function (item) {
            if (Object.keys(item).length) {
              return {
                ...item,
                file: vm.dataURLtoFile(item.preview, item.name),
              }
            } else {
              return {...item}
            }
          }),
          invoice_document: !this.lodash.isEmpty(this.value.invoice_document)
              ? this.value.invoice_document
              : {name: 'invoice_document'},
          down_payment_document: !this.lodash.isEmpty(this.value.down_payment_document)
              ? this.value.down_payment_document
              : {name: 'down payment document'},
          operational_cost_document: !this.lodash.isEmpty(this.value.operational_cost_document)
              ? this.value.operational_cost_document
              : {name: 'operational cost document'},
        })
      } else {
        // this.init = false
      }
    },
    onTicketSelected(event) {
      if (this.revert_ticket_id) {
        return null
      }
      if (this.value.id && (this.value.ticketable.ticket_id === event.id)) {
        this.$set(this.model, 'ticket', event)
        // this.updateLocalStorage()
        return null
      } else {
        if (!this.init) {
          this.$set(this, 'model', {
            total: 0,
            service_fee: 0,
            customer_id: null,
            shrimp_id: null,
            farmer_id: null,
            ordered_at: null,
            hatchery_id: null,
            shrimp_selected: null,
            down_payment: null,
            feed: null,
            unit_duration: 'days',
            files: [{}],
            purchase_items: [
              {
                fund: 'fresh',
                quality: 'fresh',
              }],
            purchase_additional_items: [{}],
            additional_fees: [],
            discounts: [],
            ticketable: {ticket_id: this.model.ticketable.ticket_id},
            ticket: {...event},
            invoice_document: {name: 'invoice document'},
            down_payment_document: {name: 'down payment document'},
          })
          this.updateLocalStorage()
        } else {
          this.$set(this.model, 'ticket', event)
          // this.init = false
        }
      }
    },
    parterSelected(payload) {
      if (!this.lodash.isEmpty(payload)) {
        this.$set(this.model.payment, 'from_bank_account_id', payload && payload.id)
      } else {
        this.model.partner_id = null
      }
    },
    addPurchaseItem() {
      this.model.purchase_items.push({...this.purchaseItemInitialValue})
    },
    // addItem (key) {
    //   if (['discounts', 'additional_fees'].includes(key)) {
    //     this.model[key].push({});
    //   } else {
    //     this.model[key].push({
    //       fund: 'fresh',
    //       quality: 'fresh',
    //     });
    //   }
    //   this.setPurchaseOrderTotal()
    // },
    addItem(key, val) {
      this.model[key].push(key === 'purchase_items' ? {
        ...this.purchaseItemInitialValue,
        ...val,
      } : {
        fund: 'fresh',
        quality: 'fresh',
        ...val,
      })
      this.setPurchaseOrderTotal()
    },
    undeletedItems(key) {
      return this.model[key]?.filter((r) => r._action !== 'delete')
    },
    removeItem(key, index) {
      let items = [...this.model[key]]
      let hasId = items[index]?.id

      if (!hasId) {
        items.splice(index, 1)
      } else {
        items[index]._action = 'delete'
      }

      this.$set(this.model, key, items)
      this.setPurchaseOrderTotal()
    },
    dataURLtoFile(dataUrl, filename) {
      let arr = dataUrl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, {type: mime})
    },
    onChangeAdditionalFeeTotal() {
      this.setPurchaseOrderTotal()
      this.updateLocalStorage()
    },
    onChangeDiscountTotal() {
      this.setPurchaseOrderTotal()
      this.updateLocalStorage()
    },
    onChangePurchaseItemQuantity(purchaseItem) {
      this.setPurchaseItemTotalPrice(purchaseItem)
      this.setPurchaseOrderTotal()
      this.updateLocalStorage()
    },
    onChangePurchaseItemUnitPrice(purchaseItem) {
      this.setPurchaseItemTotalPrice(purchaseItem)
      this.setPurchaseOrderTotal()
      this.updateLocalStorage()
    },
    setPurchaseItemTotalPrice(purchaseItem) {
      this.$set(purchaseItem, 'total_price', (purchaseItem.quantity || 0) * (purchaseItem.unit_price || 0))
    },
    emitModel() {
      this.$emit('input', this.lodash.cloneDeep(this.model))
    },
    addOtherOperationalCost(val) {
      this.model.other_operational_costs?.push({...val})
    },
    removeOtherOperationalCost(index) {
      this.model.other_operational_costs.splice(index, 1)
    },
    onFarmerSelected(event) {
      this.$set(this.model, 'farmer', event)
      // if(!event){
      //   this.model.farm_id = null
      // }
    },
    onFarmSelected(event) {
      this.farm = event
    },
    farmerLabel(value) {
      const {code, name, region_full_name, phone_number} = value
      let additional = code
      if (region_full_name) additional = `${additional} - ${region_full_name}`
      if (phone_number) additional = `${additional} - ${phone_number}`

      return `${name} (${additional})`
    },
    latestIndexUndeletedItems(key) {
      let items = [...this.model[key]]
      let index = 0

      for (let i = items.length - 1; i >= 0; i--) {
        let hasActionDelete = items[i]._action === 'delete'
        if (!hasActionDelete) {
          index = i
          break
        }
      }

      return index
    },
    onCustomerSelected(event) {
      this.model.customer = event
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .custom-file {
    height: 0;
    .custom-file-label {
      height: 0;
      padding: 0;
      margin: 0;
    }
  }
}
.empty-state {
  color: #ACAEBD;
}

.section-label {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #0084F3;
}

.button-remove-item {
  color: #F14250 !important;
}
</style>